export const fullNameStatus = [
    { value: 'خالی است', label: 'خالی است' },
    { value: 'پر شده است', label: 'پر شده است' },
]

export const emialStatus = [
    { value: 'برابر است با', label: 'برابر است با' },
    { value: 'برابر نیست', label: 'برابر نیست' },
    { value: 'شامل', label: 'شامل' },
    { value: 'شامل نمی شود', label: 'شامل نمی شود' },
    { value: 'شروع می شود با', label: 'شروع می شود با' },
    { value: 'شروع نمی شود با', label: 'شروع نمی شود با' },
    { value: 'به پایان می رسد با', label: 'به پایان می رسد با' },
    { value: 'به پایان نمی رسد با', label: 'به پایان نمی رسد با' },
    { value: 'خالی است', label: 'خالی است' },
    { value: 'پر شده است', label: 'پر شده است' },
]


export const dateStatus = [
    { value: 'خالی است', label: 'خالی است' },
    { value: 'پر شده است', label: 'پر شده است' },
    { value: 'قبل', label: 'قبل' },
    { value: 'بعد', label: 'بعد' },
    { value: 'برابر با تاریخ است', label: 'برابر با تاریخ است' },
    { value: 'برابر با تاریخ نیست', label: 'برابر با تاریخ نیست' },
    { value: 'برابر با روز است', label: 'برابر با روز است' },
    { value: 'برابر با روز نیست', label: 'برابر با روز نیست' },
]


export const appointmentStatus = [
    { value: 'برابر است با', label: 'برابر است با' },
    { value: 'برابر نیست', label: 'برابر نیست' },
    { value: 'خالی است', label: 'خالی است' },
    { value: 'پر شده است', label: 'پر شده است' },
    { value: 'قبل', label: 'قبل' },
    { value: 'بعد', label: 'بعد' },
    { value: 'برابر با تاریخ است', label: 'برابر با تاریخ است' },
    { value: 'برابر با تاریخ نیست', label: 'برابر با تاریخ نیست' },
    { value: 'برابر با روز است', label: 'برابر با روز است' },
    { value: 'برابر با روز نیست', label: 'برابر با روز نیست' },
]


export const fillintheBlankStatus = [
    { value: 'برابر است با', label: 'برابر است با' },
    { value: 'برابر نیست', label: 'برابر نیست' },
    { value: 'شامل', label: 'شامل' },
    { value: 'شامل نمی شود', label: 'شامل نمی شود' },
    { value: 'شروع می شود با', label: 'شروع می شود با' },
    { value: 'شروع نمی شود با', label: 'شروع نمی شود با' },
    { value: 'به پایان می رسد با', label: 'به پایان می رسد با' },
    { value: 'به پایان نمی رسد با', label: 'به پایان نمی رسد با' },
    { value: 'خالی است', label: 'خالی است' },
    { value: 'پر شده است', label: 'پر شده است' },
]


export const productListStatus = [
    { value: 'برابر است با', label: 'برابر است با' },
    { value: 'برابر نیست', label: 'برابر نیست' },
    { value: 'خالی است', label: 'خالی است' },
    { value: 'پر شده است', label: 'پر شده است' },
]


export const numberStatus = [
    { value: 'برابر است با', label: 'برابر است با' },
    { value: 'برابر نیست', label: 'برابر نیست' },
    { value: 'خالی است', label: 'خالی است' },
    { value: 'پر شده است', label: 'پر شده است' },
    { value: 'کمتر از', label: 'کمتر از' },
    { value: 'بزرگتر از', label: 'بزرگتر از' },
]


export const timeStatus = [
    { value: 'برابر است با', label: 'برابر است با' },
    { value: 'برابر نیست', label: 'برابر نیست' },
    { value: 'خالی است', label: 'خالی است' },
    { value: 'پر شده است', label: 'پر شده است' },
    { value: 'قبل', label: 'قبل' },
    { value: 'بعد', label: 'بعد' },
]


export const inputStatus = [
    { value: 'شامل', label: 'شامل' },
    { value: 'شامل نمی شود', label: 'شامل نمی شود' },
    { value: 'خالی است', label: 'خالی است' },
    { value: 'پر شده است', label: 'پر شده است' },
]
